import React from 'react';

export const EMPTY_COMPANY = { company_name: '', vat_number: '', address: '', city: '', postal_code: '' };

const FIELDS = [
  { name: 'company_name', label: 'Ragione sociale', span: 2 },
  { name: 'vat_number', label: 'Partita IVA', placeholder: '11 cifre', inputMode: 'numeric', maxLength: 13, pattern: '(IT|it)?\\s*\\d{11}', title: 'La Partita IVA deve contenere 11 cifre' },
  { name: 'postal_code', label: 'CAP', inputMode: 'numeric', maxLength: 5, pattern: '\\d{5}', title: 'Il CAP deve contenere 5 cifre' },
  { name: 'address', label: 'Sede legale (via e numero)', span: 2 },
  { name: 'city', label: 'Città e provincia', placeholder: 'es. Marigliano (NA)', span: 2 },
];

export const formatApiError = (detail, fallback) => {
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map(e => (e?.msg || '').replace(/^Value error, /, '')).filter(Boolean).join(' · ');
  return fallback;
};

export const CompanyFields = ({ value, onChange }) => (
  <div className="grid grid-cols-2 gap-4" data-testid="company-fields">
    {FIELDS.map(f => (
      <div key={f.name} className={f.span === 2 ? 'col-span-2' : ''}>
        <label className="block text-sm font-medium mb-2">{f.label}</label>
        <input
          type="text"
          name={f.name}
          value={value[f.name]}
          onChange={e => onChange({ ...value, [f.name]: e.target.value })}
          placeholder={f.placeholder}
          inputMode={f.inputMode}
          maxLength={f.maxLength}
          pattern={f.pattern}
          title={f.title}
          className="input-field"
          required
          data-testid={`company-${f.name.replace('_', '-')}`}
        />
      </div>
    ))}
  </div>
);
